// Your warehouse locations
const warehouses = [
    { id: 1, name: 'Brisbane' }, // Brisbane
    { id: 2, name: 'Sydney' }, // Sydney
    { id: 3, name: 'Melbourne' }, // Melbourne
    // Add more warehouse locations if needed
];

function getNearestWarehouse() {
    const storedProductVendor = localStorage.getItem("productVendor");
    console.log('Stored Product Vendor:', storedProductVendor);

    if (storedProductVendor) {
        const warehouse = warehouses.find(
            (warehouse) => warehouse.name === storedProductVendor
        );
        console.log('Nearest Warehouse:', warehouse);
        return warehouse;
    }

    console.log('No stored product vendor found. Nearest Warehouse: null');
    return null;
}

function setDefaultPickupLocation() {
    const $pickupLocationSelect = $('#location_153695');
    if ($pickupLocationSelect.length) {
        $pickupLocationSelect.val(nearestWarehouse.id);
        $pickupLocationSelect.trigger('change');
    } else {
        setTimeout(setDefaultPickupLocation, 100);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    // Set up a MutationObserver to detect when the Zapiet widget is added to the DOM
    const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                for (const node of mutation.addedNodes) {
                    if (node.id === 'storePickupApp') {
                        setDefaultPickupLocation();
                        // Disconnect the observer once the widget is found
                        observer.disconnect();
                        break;
                    }
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    function setDefaultPickupLocation() {
        const nearestWarehouse = getNearestWarehouse(); // Call the function to get the nearest warehouse

        if (!nearestWarehouse) {
            console.log('No nearest warehouse found. Retrying...');
            setTimeout(setDefaultPickupLocation, 100);
            return;
        }

        const locationIdMap = {
            1: '153695', // Brisbane
            2: '153697', // Sydney
            3: '153696', // Melbourne
        };

        const locationId = locationIdMap[nearestWarehouse.id];
        console.log('locationId:', locationId);

        if (locationId) {
            const parentDivSelector = `#location_${locationId}`;
            console.log('parentDivSelector:', parentDivSelector);
            const parentDiv = document.querySelector(parentDivSelector);
            console.log('parentDiv:', parentDiv);

            if (parentDiv) {
                const radioInput = parentDiv.querySelector(`input[value="${locationId}"]`);
                console.log('radioInput:', radioInput);

                if (radioInput) {
                    console.log('Setting radio input checked to true.');
                    radioInput.checked = true;
                    radioInput.dispatchEvent(new Event('change'));
                } else {
                    console.log('Radio input not found. Retrying...');
                    setTimeout(setDefaultPickupLocation, 100);
                }
            } else {
                console.log('Parent div not found. Retrying...');
                setTimeout(setDefaultPickupLocation, 100);
            }
        }
    }
});

